import { Vue, Component, Prop } from 'vue-property-decorator'
import { RecipientMethod } from '../../types'

@Component
export default class RecipientMethodProp extends Vue {
  @Prop({ required: false, default: RecipientMethod.Manually }) recipientMethod!: RecipientMethod;
}
